"use client"

import { Button, type ButtonProps } from "@rarible_int/anaconda_ui_components"
import { useCallback } from "react"
import { createCalendarEvent } from "./create-calendar-event"
import { downloadNewFile } from "./download-file"

interface EventAttributes {
  title: string
  description: string
  startDate: Date
  endDate: Date
  url: string
}

interface Props extends Omit<ButtonProps, "onClick"> {
  eventAttributes: EventAttributes
}

export function AddToCalendarButton({ eventAttributes, ...props }: Props) {
  const download = useCallback(async () => {
    const calendarEvent = await createCalendarEvent(eventAttributes)
    const fileName = getFileName(eventAttributes)

    downloadNewFile(fileName, "text/calendar", calendarEvent)
  }, [eventAttributes])

  return <Button {...props} onClick={download} />
}

const getFileName = (eventAttributes: EventAttributes) => {
  return `${eventAttributes.title.toLowerCase().replace(/ /g, "-")}.ics`
}
